
// Base.
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import BlueButton from '../Atomic/BlueButton.vue'

// Used Models.
import { User } from '../../models/user'
import ProgressLinear from '../../components/Atomic/ProgressLinear.vue'

// Used for notifications.
import {INotificationService} from '../../services/NotificationService'
import UserService from '@/services/UserService'
import ErrorHandlerService from '@/services/ErrorHandlerService'

@Component({
  components: {
    BlueButton,
    ProgressLinear,
  },
})
export default class DisplayActivationKey extends Vue {
  @Prop() public readonly user: User
  private isPending: boolean = false
  private activationKey: string = ''

  // Used to handle errors
  private errorHandlerService: ErrorHandlerService

  // Used for notification.
  private $notificationService!: INotificationService

  private async fetchActivationKey() {
    this.isPending = true
    try {
      const response = await UserService.getDefaultStudentsPasswords([this.user.ad_personne_id])
      this.activationKey = response[0]['password']
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    } finally {
      this.isPending = false
    }
  }
}
